import { gql } from "@apollo/client/core";
import { GlobalPropertyState } from "../types";
import { graphQlManager } from "../services/server";

export const globalPropertyStateAspectFragment = gql`
    fragment GlobalPropertyStateAspectFields on GlobalPropertyStateAspect {
        name
        value
        type
        channel
        storage {
            ... on GlobalPropertyStateColorOptionStorage {
                customColor
            }
            ... on GlobalPropertyStateFileUploadStorage {
                originalAssetKey
                backgroundRemovedAssetKey
                useOriginalAsset
                colors {
                    key
                    browserValue
                    pmsValue
                }
            }
        }
    }
`;

export const createGlobalPropertyStateMutation = gql`
    ${globalPropertyStateAspectFragment}
    mutation CreateGlobalPropertyState($bundleId: String!) {
        globalPropertyStateCreate(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`;

export const updateGlobalPropertyStateMutation = gql`
    ${globalPropertyStateAspectFragment}
    mutation UpdateGlobalPropertyState($id: String!, $aspects: [GlobalPropertyStateAspectInput]!) {
        globalPropertyStateUpdate(id: $id, aspects: $aspects) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`;

export const getGlobalPropertyStateQuery = gql`
    ${globalPropertyStateAspectFragment}
    query GetGlobalPropertyState($bundleId: String!) {
        globalPropertyState(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`;

/**
 * Gets the raw Global Property State for a bundle.
 */
export const getGlobalPropertyStateForBundle = async (bundleId: string): Promise<GlobalPropertyState | undefined> => {
    const resp = await graphQlManager.getShadowGraphqlClient().query<{ globalPropertyState: GlobalPropertyState }>({
        query: getGlobalPropertyStateQuery,
        fetchPolicy: "cache-first",
        errorPolicy: "all",
        variables: {
            bundleId,
        },
    });
    return resp.data.globalPropertyState;
};
